/**
 * Game type enum.
 */
export enum GameTypeEnum {
  Friendly,
  Wager,
  Ranking,
  Tournament,
  League,
}
